export default __webpack_public_path__ + "packs/static/media/alert.0e3efe32.mp3";